import { render, staticRenderFns } from "./ListSensorWarnings.vue?vue&type=template&id=74310ab4&scoped=true&"
import script from "./ListSensorWarnings.vue?vue&type=script&lang=js&"
export * from "./ListSensorWarnings.vue?vue&type=script&lang=js&"
import style0 from "./ListSensorWarnings.vue?vue&type=style&index=0&id=74310ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74310ab4",
  null
  
)

/* custom blocks */
import block0 from "./ListSensorWarnings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports